/** A friendly "% left" meter for an AI token budget. Colour shifts from the
 *  brand tone to warning to danger as the budget fills, so a learner running
 *  low sees it at a glance without reading numbers. */
import { useT } from "../i18n";

export function UsageBar({
  label,
  used,
  limit,
}: {
  label: string;
  used: number;
  limit: number;
}) {
  const t = useT();
  const pct = limit > 0 ? Math.min(100, Math.round((used / limit) * 100)) : 0;
  const left = 100 - pct;
  const tone = pct >= 90 ? "bg-danger" : pct >= 70 ? "bg-warning" : "bg-brand";

  return (
    <div>
      <div className="flex items-baseline justify-between text-sm">
        <span className="font-semibold text-ink">{label}</span>
        <span className="text-muted">{t("usage.left", { pct: left })}</span>
      </div>
      <div
        className="mt-1 h-2 overflow-hidden rounded-full bg-line"
        role="progressbar"
        aria-valuenow={pct}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={label}
      >
        <div className={`h-full rounded-full ${tone}`} style={{ width: `${pct}%` }} />
      </div>
      <p className="mt-1 text-xs text-muted">
        {t("usage.used", { used: used.toLocaleString(), limit: limit.toLocaleString() })}
      </p>
    </div>
  );
}
